import { cn } from 'noddi-ui-common';
import { StorageBySeasonChart } from './charts/StorageBySeasonChart';
import { TireWearChart } from './charts/TireWearChart';
import { UpcomingBookingsChart } from './charts/UpcomingBookingsChart';
import type { FleetViewFilterInput } from './fleetViewSummaryFilterSpecs';
import { defaultFleetViewSummaryChartsTranslations, FleetViewSummaryChartsTranslations } from './fleetViewTranslations';

type Props = {
  /** The list's `filters.apiInput`, scope included, so the counts are of the cars the list shows. */
  filterParams: FleetViewFilterInput;
  summerTireTooltip?: React.ReactNode;
  winterTireTooltip?: React.ReactNode;
  showTireHotelCharts?: boolean;
  translations?: FleetViewSummaryChartsTranslations;
};

export const FleetViewSummaryCharts = ({
  filterParams,
  summerTireTooltip,
  winterTireTooltip,
  showTireHotelCharts = true,
  translations
}: Props) => {
  const t = { ...defaultFleetViewSummaryChartsTranslations, ...translations };
  const containerClassName = cn(
    'grid grid-cols-1 gap-4 md:grid-cols-2',
    showTireHotelCharts ? '2xl:grid-cols-4' : '2xl:grid-cols-1'
  );

  return (
    <div className={containerClassName}>
      {showTireHotelCharts && <StorageBySeasonChart filterParams={filterParams} translations={t} />}
      {showTireHotelCharts && (
        <TireWearChart filterParams={filterParams} season='summer' tooltip={summerTireTooltip} translations={t} />
      )}
      {showTireHotelCharts && (
        <TireWearChart filterParams={filterParams} season='winter' tooltip={winterTireTooltip} translations={t} />
      )}
      <UpcomingBookingsChart filterParams={filterParams} translations={t} />
    </div>
  );
};
